
import React, { createContext } from "react";
const CandidateListContext = createContext(null);
export default CandidateListContext;